import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider as JotaiProvider } from 'jotai';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/sonner';
import { queryClient } from '@/lib/query-client';
import { ThemeProvider } from './ThemeProvider';
import { AuthProvider } from './AuthProvider';
import { BreadcrumbsProvider } from './BreadcrumbsProvider';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <JotaiProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <BreadcrumbsProvider>
                <TooltipProvider>
                  {children}
                  <Toaster richColors closeButton position="top-right" />
                </TooltipProvider>
              </BreadcrumbsProvider>
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </JotaiProvider>
    </ThemeProvider>
  );
}
